/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PayWithCouponAccessPlanDataParser = 
/* #__PURE__ */ parsers.object([['code', codecString]]);
export class PayWithCouponAccessPlanData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PayWithCouponAccessPlanDataParser.decode(input).map(res => new PayWithCouponAccessPlanData(res));
    }
    static unsafeDecode(input) {
        return PayWithCouponAccessPlanData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PayWithCouponAccessPlanDataParser.encode(data);
    }
    static schema() {
        return PayWithCouponAccessPlanDataParser.schema();
    }
}
